<template>
  <div>
    <b-row class="adduserwidth">
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <div class="adduserside">
        <sidebarSettingsComponent></sidebarSettingsComponent>
      </div>
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main col-md-8">
        <b-row class="col-md-12 addusersidebar">
          <b-col md="12">
            <!-- <div class="pull-right"> -->
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <!--  <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span> -->
                <i
                  class="fa fa-sliders"
                  aria-hidden="true"
                  style="font-size:20px"
                ></i>
              </template>
              <b-dropdown-item style="font-size: 20px;">
                <div>
                  <router-link
                    to="/updateProfile"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;
                    <span>Profile</span>
                  </router-link>
                </div>
                <div
                  v-if="
                    this.user_type == 'Admin' ||
                      this.user_type == 'Brand_Manager' ||
                      this.user_type == 'Quality_Head' ||
                      this.user_type == 'Quality_Controller'
                  "
                >
                  <router-link
                    to="/usersdetails"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Users</span>
                  </router-link>
                </div>
                <div
                  v-if="
                    this.user_type == 'Brand_Manager' ||
                      this.user_type == 'Quality_Head'
                  "
                >
                  <router-link
                    to="/mybranddetails"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Collections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-shopping-cart" aria-hidden="true"></i
                    >&nbsp;&nbsp;&nbsp;
                    <span>My Brands</span>
                  </router-link>
                </div>
                <div style="display:none">
                  <router-link
                    to="/updateProfile"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Vendors</span>
                  </router-link>
                </div>
                <div v-if="this.user_type == 'Admin'">
                  <router-link
                    to="/manage_brands"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp;
                    <span>Manage Brands</span>
                  </router-link>
                </div>
                <div v-if="this.user_type == 'Admin'">
                  <router-link
                    to="/marginmaster"
                    class="nav-link design-container-details__sidebar-item flex f-w-semi-bold "
                    title="Coll ections"
                    style="padding-left:30px;"
                  >
                    <i class="fa fa-pie-chart" aria-hidden="true"></i>

                    &nbsp;&nbsp;&nbsp;
                    <span>Manage Margin Master</span>
                  </router-link>
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <!-- </div> -->
          </b-col>
        </b-row>
        <div class="col-md-12">
          <b-row>
            <b-col md="12">
              <b-card-body>
                <div class="col-md-12 pull-left"><h3>Add User</h3></div>
                <b-form
                  @submit.prevent="validateForm('form-1')"
                  data-vv-scope="form-1"
                >
                  <div class="col-md-6 pull-left">
                    <b-form-group>
                      <label for="first name"> Name</label>
                      <b-form-input
                        type="text"
                        name="full_name"
                        v-model="customer.full_name"
                        v-validate="'required|min:3|max:30'"
                        :class="{
                          input: true,
                          'text-danger': errors.has('form-1.full_name'),
                        }"
                        placeholder="Enter Name"
                      >
                      </b-form-input>
                      <b-input-group>
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('full_name')"
                          ></i>
                        </span>
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.full_name')"
                          class="help text-danger"
                          >{{ errors.first("form-1.full_name") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 pull-right">
                    <b-form-group>
                      <label for="contact_no">Contact Number</label>
                      <b-input-group>
                        <b-form-input
                          class="input"
                          type="text"
                          id="contact_no"
                          name="contact_no"
                          maxlength="10"
                          v-model="customer.contact_no"
                          v-validate="'required|digits:10'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-1.contact_no'),
                          }"
                          placeholder="Enter Contact Number"
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('contact_no')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.contact_no')"
                          id="addmblnbrmsg"
                          class="help text-danger"
                          >{{ errors.first("form-1.contact_no") }}
                        </code>
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <div class="col-md-6 pull-left">
                    <b-form-group>
                      <label for="email_id">Email ID</label>
                      <b-input-group class="mb-3">
                        <b-form-input
                          class="input"
                          type="text"
                          v-model="customer.email_id"
                          name="email_id"
                          id="email_id"
                          v-validate="'required|email'"
                          :class="{
                            input: true,
                            'text-danger': errors.has('form-1.email_id'),
                          }"
                          placeholder="Enter Email ID"
                        >
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span
                          style="width:240px"
                          v-show="errors.has('form-1.email_id')"
                          class="help text-danger"
                          >{{ errors.first("form-1.email_id") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <div class="col-md-6 pull-right">
                    <b-form-group>
                      <label for="role">User Role</label>
                      <b-input-group class="mb-3">
                        <b-form-select
                          v-if="this.user_type == 'Admin'"
                          v-model="customer.role"
                          name="role"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.role'),
                          }"
                          @change="checkusertype(customer.role)"
                        >
                          <option value="">--Select--</option>
                          <option value="1">Brand Manager</option>
                          <option value="7">Quality Controller</option>
                          <option value="11">Planner Admin</option>
                          <option value="13">Buying Head</option>
                          <option value="14">ME User</option>
                        </b-form-select>

                        <b-form-select
                          v-if="user_type == 'Quality_Controller'"
                          v-model="customer.role"
                          name="role"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.role'),
                          }"
                        >
                          <option value="">--Select--</option>
                          <option value="8">QC Executive</option>
                        </b-form-select>

                        <b-form-select
                          v-if="user_type == 'Buyer'"
                          v-model="customer.role"
                          name="role"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.role'),
                          }"
                        >
                          <option value="">--Select--</option>
                          <option value="10">Junior Buyer</option>
                        </b-form-select>

                        <b-form-select
                          v-if="user_type == 'Planner_Admin'"
                          v-model="customer.role"
                          name="role"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.role'),
                          }"
                        >
                          <option value="">--Select--</option>
                          <option value="12">Planner</option>
                        </b-form-select>

                        <b-form-select
                          v-if="this.user_type == 'Brand_Manager'"
                          v-model="customer.role"
                          name="role"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.role'),
                          }"
                          @change="displaydesignation(customer.role)"
                        >
                          <option value="">--Select--</option>
                          <option value="2">Buyer</option>
                          <option value="3">Designer</option>
                          <option value="4">Fit Technician</option>
                          <option value="5">Design Head</option>
                          <option value="6">PO Executive</option>
                        </b-form-select>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('role')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.role')"
                          id="statustxt"
                          class="help text-danger"
                          >{{ errors.first("form-1.role") }}
                        </code>
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <div
                    class="col-md-6 pull-left"
                    v-if="disable_brand != true"
                    id="brand_block"
                  >
                    <b-form-group>
                      <!-- <label for="selectbrand" v-if="customer.role!=7">Select Brand</label> -->
                      <label for="selectbrand" v-if="customer.role == 7"
                        >Select City</label
                      >
                      <!-- <b-input-group class="mb-3"> -->
                      <!-- <b-input-group class="mb-3" v-if="user_type!='Admin' && user_type!='Quality_Controller'" > -->
                      <!-- <b-form-select :plain="true"  v-model="sel_brand"  :options="options">

                    </b-form-select></b-input-group> -->

                      <!-- <ejs-multiselect id='multiselect' placeholder="Select Brand" v-model="brand_id" name="assigned_brand" :dataSource='assigned_brand'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='brandfields' :class="{'input': true, 'is-invalid': errors.has('form-5.assigned_brand') } " >
                    </ejs-multiselect>
                  </b-input-group> -->

                      <b-input-group
                        class=""
                        v-if="
                          user_type == 'Admin' &&
                            user_type != 'Quality_Controller' &&
                            customer.role == 7
                        "
                        required
                      >
                        <b-form-select
                          v-model="city"
                          id="city"
                          name="city"
                          placeholder="Please Select city"
                        >
                          <option value="">--Select--</option>
                          <option value="Delhi ">Delhi</option>
                          <option value="Ludhiana">Ludhiana</option>
                          <option value="Mumbai">Mumbai</option>
                          <option value="Jaipur">Jaipur</option>
                          <option value="Kolkata">Kolkata</option>
                          <option value="New delhi">New delhi</option>
                          <option value="Tirupur">Tirupur</option>
                          <option value="Bangalore">Bangalore</option>
                          <option value="Lahuri">Lahuri</option>

                          <!-- <option  :value="brand_list.brand_id" v-for="brand_list in assigned_brand">{{ brand_list.brand_title }}</option> -->
                        </b-form-select>
                        <b-input-group class="">
                          <span
                            style="width:240px"
                            v-show="errors.has('form-1.city')"
                            class="help text-danger"
                            >{{ errors.first("form-1.city") }}</span
                          >
                        </b-input-group>
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <!-- <b-input-group class="mb-3" v-if="customer.role==7 && user_type!='Quality_Controller'" id="brand_block"> 
                           <b-form-select :plain="true"  v-model="sel_brand"  :options="options">

                    </b-form-select></b-input-group>

                        <ejs-multiselect id='multiselect' placeholder="Select Brand" v-model="brand_id" name="assigned_brand" :dataSource='brandrecord'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='brandfields' :class="{'input': true, 'is-invalid': errors.has('form-5.assigned_brand') } " >
                    </ejs-multiselect>
                  </b-input-group>  -->

                  <!-- <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('assigned_brand')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.assigned_brand')">{{ errors.first('form-1.assigned_brand') }}</span>
                        </b-input-group>

                  <b-input-group class="mb-3" v-if="user_type=='Quality_Controller'">
                <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="brand_list.brand_id" v-for="brand_list in assigned_brand">{{ brand_list.brand_title }}</option>
                </b-form-select>  -->
                  <!-- <b-form-select 
                  :plain="true"
                  v-model="selected_brand"
                  :options="brandrecord.brand_title">
                </b-form-select> -->

                  <!-- </b-input-group> -->

                  <!--  <b-form-select v-model="brandrecord.brand_id" id="sel_brand" name="sel_brand" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  v-for="opt in brandrecord">{{ opt.brand_title }}</option>
                </b-form-select>  -->
                  <!-- <b-input-group class="mb-3" v-if="this.user_type=='Admin' && customer.role!=7">
                <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
                </b-form-select>  -->
                  <!-- <b-form-select 
                  :plain="true"
                  v-model="selected_brand"
                  :options="brandrecord.brand_title">
                </b-form-select> -->

                  <!-- </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('options')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.options')">{{ errors.first('form-1.options') }}</span>
                        </b-input-group>
                      </b-form-group>
   11               </div> -->

                  <div class="col-md-6 pull-left">
                    <b-form-group>
                      <label for="pincode">Status</label>
                      <b-input-group>
                        <b-form-select
                          v-model="customer.isactive"
                          name="status"
                          v-validate="'required|'"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-1.status'),
                          }"
                        >
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('status')"
                          ></i>
                        </span>
                        <code
                          v-show="errors.has('form-1.status')"
                          id="statustxt"
                          class="help text-danger"
                          >{{ errors.first("form-1.status") }}
                        </code>
                      </b-input-group>
                    </b-form-group>
                  </div>

                  <!-- <div class="col-md-6 pull-left" id="designation_block" style="display: none;" v-if="this.user_type=='Brand_Manager'" >   
                      <b-form-group>
                        <label for="pincode">Designation</label>
                        <b-input-group > -->
                  <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                        </b-form-input> -->
                  <!-- <b-form-select v-model="customer.designation" name="designation"  :class="{'input': true, 'is-invalid': errors.has('form-1.designation') }">
                          <option value="">--Select--</option>
                          <option value="Senior Buyer">Senior Buyer</option>
                          <option value="Junior Buyer">Junior Buyer</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('designation')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.designation')" id="statustxt" class="help text-danger">{{ errors.first('form-1.designation') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </div> -->
                  <!-- v-if="this.user_type=='Admin'" -->
                  <!-- Code For Cat -->
                  <!-- <div class="col-md-6 pull-right" id="cat_block"> 
                      <b-form-group>
                        <label for="selectbrand">Select Category</label>
                        <b-input-group class="mb-3">

                          <ejs-multiselect id='multiselect' placeholder="Select Category" v-model="selected_cat_id" name="selected_cat_id" :dataSource='cat_arr' @change="getSubcatlist(selected_cat_id)" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='catagentfields' :class="{'input': true, 'is-invalid': errors.has('form-5.selected_cat_id') }" >
                    </ejs-multiselect> -->

                  <!-- @select="getSubCategoryList($event,selected_cat_id)" -->
                  <!-- </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('selected_cat_id')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.selected_cat_id')">{{ errors.first('form-1.selected_cat_id') }}</span>
                        </b-input-group>
                      </b-form-group>
                  </div> -->
                  <!-- Code For Cat Ends -->
                  <!-- <div class="col-md-6 pull-left" id="subcat_block" >   
                      <b-form-group>
                        <label for="selectbrand">Select Subcategory</label>
                        <b-input-group class="mb-3">

                          <ejs-multiselect id='multiselect' placeholder="Select Subcategory" v-model="sel_subcat" name="sel_subcat" :dataSource='sub_cat_arr'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :class="{'input': true, 'is-invalid': errors.has('form-5.sel_subcat') }" >
                    </ejs-multiselect> -->

                  <!--  <b-form-select v-model="brandrecord.brand_id" id="sel_brand" name="sel_brand" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  v-for="opt in brandrecord">{{ opt.brand_title }}</option>
                </b-form-select>  -->
                  <!-- <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
                </b-form-select>  -->
                  <!-- <b-form-select 
                  :plain="true"
                  v-model="selected_brand"
                  :options="brandrecord.brand_title">
                </b-form-select> -->

                  <!-- </b-input-group>
                        <b-input-group class="mb-3">
                          <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('sel_subcat')" ></i>
                        </span>
                        <span class="icon has-text-warning"
                         v-show="errors.has('form-1.sel_subcat')">{{ errors.first('form-1.sel_subcat') }}</span>
                        </b-input-group>
                      </b-form-group>
                  </div> -->
                  <!-- 
                  <div
                    class="col-md-6 pull-right"
                    v-if="this.user_type == 'Quality_Controller'"
                  >
                    <b-form-group>
                      <label for="selectbrand">Select Vendors</label>
                      <b-input-group class="mb-3">
                        <ejs-multiselect
                          id="multiselect"
                          placeholder="Select Vendors"
                          v-model="selected_vendors"
                          name="selected_vendors"
                          :dataSource="vendor_list_arr"
                          :showSelectAll="showSelectAll"
                          selectAllText="Select All"
                          unSelectAllText="unSelect All"
                          :fields="vendorfields"
                          :class="{
                            input: true,
                            'is-invalid': errors.has('form-5.vendor_list_arr'),
                          }"
                        >
                        </ejs-multiselect>
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i
                            class="fa fa-warning"
                            v-show="errors.has('selected_vendors')"
                          ></i>
                        </span>
                        <span
                          class="icon has-text-warning"
                          v-show="errors.has('form-1.selected_vendors')"
                          >{{ errors.first("form-1.selected_vendors") }}</span
                        >
                      </b-input-group>
                    </b-form-group>
                  </div> -->

                  <div class="col-md-12 pull-right">
                    <footer class="column has-text-right pull-right">
                      <b-button variant="primary" size="md" type="submit"
                        >Submit</b-button
                      >&nbsp;
                      <b-button
                        variant="secondary"
                        size="md"
                        type="submit"
                        @click="$router.push('usersdetails')"
                        >Cancel</b-button
                      >
                    </footer>
                  </div>
                </b-form>
              </b-card-body>
            </b-col>
          </b-row>

          <div
            class="mt-3 mb-5"
            style="border:1px solid	#D3D3D3; display:none;"
            v-if="customer.role != 7 && user_type != 'Quality_Controller'"
          >
            <button class="btn btn-success m-2" v-b-modal.modal-1>
              Assign
            </button>
            <b-table
              class="mt-4"
              show-empty
              stacked="md"
              :items="getassign_list"
              :fields="fields1"
              :bordered="true"
            >
              <template slot="editbtn" slot-scope="row">
                <button
                  class="btn"
                  v-b-modal.modal-x
                  @click="
                    showEditModal(
                      row.item.id,
                      row.item.category_name,
                      row.item.brand_name,
                      row.item.brand_id,
                      row.item.cat_id
                    )
                  "
                >
                  Edit
                </button>
              </template>

              <template slot="deletebtn" slot-scope="row">
                <button
                  class="btn"
                  v-b-modal.modal-delete
                  @click="showDeleteModal(row.item.id)"
                >
                  Delete
                </button>
              </template>

              <template
                slot="category_nametab"
                slot-scope="row"
                v-if="
                  row.item.category_name != '' || row.item.category_name != null
                "
              >
                <span v-for="data in row.item.category_name"> {{ data }},</span>
              </template>

              <template
                slot="subcat_nametab"
                slot-scope="row"
                v-if="
                  row.item.subcat_name != '' || row.item.subcat_name != null
                "
              >
                <span v-for="data1 in row.item.subcat_name"> {{ data1 }},</span>
              </template>

              <template
                slot="brand_nametab"
                slot-scope="row"
                v-if="
                  row.item.category_name != '' || row.item.category_name != null
                "
              >
                <span v-for="data2 in row.item.brand_name">{{ data2 }}</span>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <!-- ~~~~~~~~~~~Modal for show Edit-->
      <b-modal
        title="Edit Data"
        id="modal-x"
        v-model="isEditModelVisible"
        @ok="isEditModelVisible = false"
      >
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm3('form-2')"
            data-vv-scope="form-2"
          >
            <div v-if="disable_brand != true">
              <b-card no-body>
                <b-form-group class="md-5">
                  <label for="selectbrand" v-if="customer.role != 7"
                    >Brand Name:</label
                  >

                  <b-form-input
                    type="text"
                    name="selected_brandID"
                    v-model="selected_brandname"
                    disabled
                  >
                  </b-form-input>
                  <!-- 
               <b-input-group class="mb-3"  id="brand_block"> 
               
                 <ejs-multiselect id='multiselect' placeholder="Select Brand" v-model="brand_id" name="assigned_brand" :dataSource='brandrecord'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='brandfields' :class="{'input': true, 'is-invalid': errors.has('form-2.assigned_brand') } " >
                 </ejs-multiselect>
               </b-input-group> 

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('assigned_brand')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-2.assigned_brand')">{{ errors.first('form-2.assigned_brand') }}</span>
             </b-input-group> -->

                  <b-input-group
                    class="mb-3"
                    v-if="user_type == 'Quality_Controller'"
                  >
                    <b-form-select
                      v-model="brand_id"
                      id="brand_id"
                      name="brand_id"
                      placeholder="Please Select Brand."
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.brand_id"
                        v-for="brand_list in assigned_brand"
                        >{{ brand_list.brand_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>

                  <!-- <b-input-group class="mb-3" v-if="this.user_type=='Admin' && customer.role!=7">
             <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                     <option :value="selected"  >--Select--</option>
                     <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
             </b-form-select> 
             </b-input-group>

             <b-input-group class="mb-3">
               <span class="icon has-text-warning">
               <i class="fa fa-warning" v-show="errors.has('options')" ></i>
             </span>
             <span class="icon has-text-warning"
               v-show="errors.has('form-1.options')">{{ errors.first('form-1.options') }}</span>
             </b-input-group> -->
                </b-form-group>

                <div
                  class="col-md-6 pull-left"
                  id="designation_block"
                  style="display: none;"
                >
                  <b-form-group>
                    <label for="pincode">Designation</label>
                    <b-input-group>
                      <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                     </b-form-input> -->
                      <b-form-select
                        v-model="customer.designation"
                        name="designation"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-2.designation'),
                        }"
                      >
                        <option value="">--Select--</option>
                        <option value="Senior Buyer">Senior Buyer</option>
                        <option value="Junior Buyer">Junior Buyer</option>
                      </b-form-select>
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i
                          class="fa fa-warning"
                          v-show="errors.has('designation')"
                        ></i>
                      </span>
                      <code
                        v-show="errors.has('form-2.designation')"
                        id="statustxt"
                        class="help text-danger"
                        >{{ errors.first("form-2.designation") }}
                      </code>
                    </b-input-group>
                  </b-form-group>
                </div>

                <b-form-group>
                  <label for="selectbrand">Category Name</label>

                  <b-form-input
                    type="text"
                    name="selected_catID"
                    v-model="selected_catname"
                    disabled
                  >
                  </b-form-input>
                  <!-- <b-input-group class="mb-3">

                 <ejs-multiselect id='multiselect' placeholder="Select Category" v-model="selected_cat_id" name="selected_cat_id" :dataSource='cat_arr' @change="getSubcatlist(selected_cat_id)" :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='catagentfields' :class="{'input': true, 'is-invalid': errors.has('form-2.selected_cat_id') }" >
           </ejs-multiselect> -->

                  <!-- @select="getSubCategoryList($event,selected_cat_id)" -->
                  <!-- </b-input-group>
               <b-input-group class="mb-3">
                 <span class="icon has-text-warning">
                 <i class="fa fa-warning" v-show="errors.has('selected_cat_id')" ></i>
               </span>
               <span class="icon has-text-warning"
                 v-show="errors.has('form-2.selected_cat_id')">{{ errors.first('form-2.selected_cat_id') }}</span>
               </b-input-group>-->
                </b-form-group>

                <b-form-group id="subcat_block">
                  <label for="selectbrand">Select Subcategory</label>
                  <b-input-group class="mb-3">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Subcategory"
                      v-model="sel_subcat"
                      name="sel_subcat"
                      :dataSource="sub_cat_arr"
                      :showSelectAll="showSelectAll"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="agentfields"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.sel_subcat'),
                      }"
                    >
                    </ejs-multiselect>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('sel_subcat')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.sel_subcat')"
                      >{{ errors.first("form-2.sel_subcat") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="cancelassignmodal()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>

      <!-- ~~~~~~~~~~~~~~Modal end for Edit -->

      <!-- ~~~~~~~~~~~Modal for show Delete-->
      <b-modal
        title="Delete Data"
        id="modal-delete"
        v-model="isDeleteModelVisible"
        @ok="isDeleteModelVisible = false"
      >
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-4')"
            data-vv-scope="form-2"
          >
            <div v-if="disable_brand != true">
              <b-card no-body>
                <p>Are you sure want to delete?</p>
                <!-- {{this.deleteId}} -->

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Delete</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="cancelassignmodalD()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>

      <!-- ~~~~~~~~~~~~~~Modal end for Delete -->

      <b-modal
        title="Assign Category, Sub-category and Brand to user"
        id="modal-1"
        v-model="assign_category"
        @ok="assign_category = false"
      >
        <template slot="header" slot-scope="{ hide }">
          <!-- <h5>Assign Category, Sub-category and Brand to user</h5> -->
          <!-- <b-form-group style="float:right;"> -->
          <b-button variant="danger" @click="editcancel()"
            ><i class="fa fa-times"></i
          ></b-button>
          <!-- </b-form-group>  -->
        </template>

        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm2('form-2')"
            data-vv-scope="form-2"
          >
            <div v-if="disable_brand != true" id="brand_block">
              <b-card no-body>
                <!-- <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2"> -->
                <b-form-group>
                  <label for="selectbrand" v-if="customer.role != 7"
                    >Select Brand</label
                  >

                  <b-input-group class="mb-3" id="brand_block">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Brand"
                      v-model="brand_id"
                      name="assigned_brand"
                      :dataSource="brandrecord"
                      :showSelectAll="showSelectAll"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="brandfields"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.assigned_brand'),
                      }"
                    >
                    </ejs-multiselect>
                  </b-input-group>

                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('assigned_brand')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.assigned_brand')"
                      >{{ errors.first("form-2.assigned_brand") }}</span
                    >
                  </b-input-group>

                  <b-input-group
                    class="mb-3"
                    v-if="user_type == 'Quality_Controller'"
                  >
                    <b-form-select
                      v-model="brand_id"
                      id="brand_id"
                      name="brand_id"
                      placeholder="Please Select Brand."
                    >
                      <option :value="selected">--Select--</option>
                      <option
                        :value="brand_list.brand_id"
                        v-for="brand_list in assigned_brand"
                        >{{ brand_list.brand_title }}</option
                      >
                    </b-form-select>
                  </b-input-group>

                  <!-- <b-input-group class="mb-3" v-if="this.user_type=='Admin' && customer.role!=7">
                <b-form-select v-model="brand_id" id="brand_id" name="brand_id" placeholder="Please Select Brand.">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="brand_list.brand_id" v-for="brand_list in brandrecord">{{ brand_list.brand_title }}</option>
                </b-form-select> 
                </b-input-group>

                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                  <i class="fa fa-warning" v-show="errors.has('options')" ></i>
                </span>
                <span class="icon has-text-warning"
                  v-show="errors.has('form-1.options')">{{ errors.first('form-1.options') }}</span>
                </b-input-group> -->
                </b-form-group>

                <div
                  class="col-md-6 pull-left"
                  id="designation_block"
                  style="display: none;"
                >
                  <b-form-group>
                    <label for="pincode">Designation</label>
                    <b-input-group>
                      <!-- <b-form-input class="input" type="text" v-model="customer.designation" name="designation" id="designation" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.designation') }" placeholder="Enter Designation">
                        </b-form-input> -->
                      <b-form-select
                        v-model="customer.designation"
                        name="designation"
                        :class="{
                          input: true,
                          'is-invalid': errors.has('form-2.designation'),
                        }"
                      >
                        <option value="">--Select--</option>
                        <option value="Senior Buyer">Senior Buyer</option>
                        <option value="Junior Buyer">Junior Buyer</option>
                      </b-form-select>
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i
                          class="fa fa-warning"
                          v-show="errors.has('designation')"
                        ></i>
                      </span>
                      <code
                        v-show="errors.has('form-2.designation')"
                        id="statustxt"
                        class="help text-danger"
                        >{{ errors.first("form-2.designation") }}
                      </code>
                    </b-input-group>
                  </b-form-group>
                </div>

                <b-form-group>
                  <label for="selectbrand">Select Category</label>
                  <b-input-group class="mb-3">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Category"
                      v-model="selected_cat_id"
                      name="selected_cat_id"
                      :dataSource="cat_arr"
                      @change="getSubcatlist(selected_cat_id)"
                      :showSelectAll="showSelectAll"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="catagentfields"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.selected_cat_id'),
                      }"
                    >
                    </ejs-multiselect>

                    <!-- @select="getSubCategoryList($event,selected_cat_id)" -->
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('selected_cat_id')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.selected_cat_id')"
                      >{{ errors.first("form-2.selected_cat_id") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <b-form-group id="subcat_block">
                  <label for="selectbrand">Select Subcategory</label>
                  <b-input-group class="mb-3">
                    <ejs-multiselect
                      id="multiselect"
                      placeholder="Select Subcategory"
                      v-model="sel_subcat"
                      name="sel_subcat"
                      :dataSource="sub_cat_arr"
                      :showSelectAll="showSelectAll"
                      selectAllText="Select All"
                      unSelectAllText="unSelect All"
                      :fields="agentfields"
                      :class="{
                        input: true,
                        'is-invalid': errors.has('form-2.sel_subcat'),
                      }"
                    >
                    </ejs-multiselect>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('sel_subcat')"
                      ></i>
                    </span>
                    <span
                      class="icon has-text-warning"
                      v-show="errors.has('form-2.sel_subcat')"
                      >{{ errors.first("form-2.sel_subcat") }}</span
                    >
                  </b-input-group>
                </b-form-group>

                <div class="col-md-12 pull-right">
                  <footer class="column has-text-right pull-right">
                    <b-button variant="primary" size="md" type="submit"
                      >Submit</b-button
                    >&nbsp;
                    <b-button
                      variant="secondary"
                      size="md"
                      type="button"
                      @click="editcancel()"
                      >Cancel</b-button
                    >
                  </footer>
                </div>
              </b-card>
            </div>
          </b-form>
        </template>
      </b-modal>
    </b-row>
  </div>
</template>
<style>
.scroll {
  width: 200px;
  height: 100px;
  overflow: scroll;
}
</style>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Router from "vue-router";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import Table from "../views/base/Table.vue";

const axios = require("axios");
export default {
  components: {
    sidebarSettingsComponent,
    Table,
  },

  data: function() {
    return {
      name: "reattemptshipment",
      customer: {},
      selected: "selected",
      deliveryagentfirstname: "",
      brandrecord: [],
      added_user: "",
      options: [],
      agentfields: { text: "sub_cattitle", value: "sub_catid" },
      catagentfields: { text: "category_title", value: "category_id" },
      brandfields: { text: "brand_title", value: "brand_id" },
      vendorfields: { text: "vendor_name", value: "vendor_id" },
      showSelectAll: true,
      showSelectAll_Brands: true,
      showSelectAll_SubCat: true,
      allowCustomValue: true,
      user_type: "",
      sel_brand: [],
      myArray: [],
      brand_id: [],
      city: "",
      brand_name_arr: [],
      disable_brand: false,
      sub_cat_arr: [],
      cat_arr: [],
      sel_subcat: [],
      assigned_brand: [],
      assign_sub_cat: [],
      designation: "",

      selected_vendors: [],
      vendor_list_arr: [],

      selected_cat_id: [],
      assign_category: false,
      items2: [],
      fields1: [
        { key: "brand_nametab", label: "Brand Name" },
        { key: "category_nametab", label: "Category Name" },
        { key: "subcat_nametab", label: "Sub-Category Name" },
        { key: "editbtn", label: "Edit" },
        { key: "deletebtn", label: "Delete" },
      ],

      deleteId: "",
      editId: "",
      getassign_list: [],
      isEditModelVisible: false,
      isDeleteModelVisible: false,
      selected_catname: "",
      selected_brandname: "",
      selected_brandID: "",
      selected_catID: [],
      addeduser_list: [],
    };
  },
  created: function() {
    this.getcategorylist();
    // this.getSubCategoryList();
    this.getselecteduserbrand();
    this.getvendorlist();
    this.getassigncatsubctidlist();

    var userData = localStorage.getItem("userData");
    if (userData) {
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      console.log("EEEEEEEEEEEEEEEEEEee", userInfo[0]);
      if (this.user_type != "Admin" && this.user_type != "Quality_Head") {
        this.getUserAssignedBrandList();
      } else {
        this.brandlisting();
      }
    }
  },
  methods: {
    getcategorylist: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      this.isBusy = true;

      axios
        .post(`${CONSTANTS.API_URL}/categoryList`, {})
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.cat_arr = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.cat_arr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getassigncatsubctidlist: function() {
      this.isBusy = true;

      var userData = localStorage.getItem("userData");
      // if (userData) {

      var userInfo = JSON.parse(userData);
      this.user_id = userInfo[0].user_id;
      this.brand_assign = userInfo[0].brand_assign;

      var Obj = {
        // user_id: this.addeduser_list,
        user_id: this.user_id,
        userid: this.addeduser_list,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getassigncatsubctidlist`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.getassign_list = this.result.returnvalue;
            this.get_cat_id = this.result.returnvalue[0].cat_id;
            console.log(this.get_cat_id, "this.get_cat_id");
            for (let i = 0; i < this.result.returnvalue.length; i++) {
              this.cat_arr.pu;
            }
          } else {
            this.getassign_list = [];
          }
        });

      // };
    },

    getSubcatlist: function(cat_id) {
      // alert(cat_id);
      this.getSubCategoryList(cat_id);
    },
    checkusertype: function(value) {
      if (value == undefined || value == null || value == "") {
        this.$fire({
          text: "Please Select User Role First",
          type: "warning",
          timer: 30000,
        });
      } else {
        if (value == 7) {
          // if(this.user_type=='Quality_Controller'){
          //   document.getElementById('brand_block').style.display="none";
          // }
          document.getElementById("cat_block").style.display = "none";
          // document.getElementById('subcat_block').style.display="none";
        } else {
          document.getElementById("brand_block").style.display = "block";
          document.getElementById("cat_block").style.display = "block";
          document.getElementById("subcat_block").style.display = "block";
        }
      }
    },
    getvendorlist: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      this.isBusy = true;

      axios
        .post(`${CONSTANTS.API_URL}/getvendorlist`, {})
        .then((response) => {
          // alert("In")
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.vendor_list_arr = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.vendor_list_arr = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    //Code For Select Brand
    getselecteduserbrand: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      this.isBusy = true;

      var Obj = {
        user_id: userInfo[0].user_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getAllocateddBrandList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.assigned_brand = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.assigned_brand = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    //Code Ends For Select Brand

    displaydesignation(value) {
      // document.getElementById("designation_block").style.display="block";
      if (value == 2) {
        document.getElementById("designation_block").style.display = "block";
      } else {
        document.getElementById("designation_block").style.display = "none";
      }
    },

    /******Function To Get Sub Category List********/
    getSubCategoryList: function(value) {
      // alert(value);
      // document.getElementById('subcat_block').style.display="block";
      // console.log("EEEEEEEEEEEEEEEEEEe",e);
      var selected_category = [];
      console.log("::::::::::::::::::::::", this.selected_cat_id);
      selected_category.push(this.selected_cat_id);
      const Obj = {
        cat_id: value,
      };
      var userdata = localStorage.getItem("userData");
      axios
        .post(`${CONSTANTS.API_URL}/getSubCategoryList`, Obj)
        .then((response) => {
          //document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.sub_cat_arr = this.result.returnvalue;
            console.log("JJJJJJJJJJJJJJJJ", this.sub_cat_arr);
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.sub_cat_arr = [];
            this.totalRows = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (
            this.user_type == "Admin" ||
            this.user_type == "Quality_Controller" ||
            this.user_type == "Brand_Manager" ||
            this.user_type == "Buyer" ||
            this.user_type == "Planner_Admin" 
          ) {
            this.addAgentInfo();
            // if(this.sel_subcat.length>0 && this.brand_id!=0){
            //   this.addAgentInfo();
            // }

            if (this.city == "" && this.customer.role == 7) {
              // alert("Please Select city");
              this.$fire({
                text: "Please Select City",
                type: "warning",
                timer: 30000,
              });
            }
          }
        }
      });
    },
    chkmobileVal() {
      var chkValidate = true;
      // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("contact_no").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },

    //disable brand function
    disablebrand: function(value) {
      if (value == 4) {
        this.disable_brand = true;
      } else {
        this.disable_brand = false;
      }
    },
    // Add New User
    addAgentInfo: function() {
      document.getElementById("overlay").style.display = "block";
      var chkmobileVal = this.chkmobileVal();
      var assign_brand = [];
      console.log("55555555555555", this.brand_id);
      assign_brand = this.brand_id;
      console.log("66666666666666", assign_brand);
      // var assign_vendors=[];
      // assign_vendors.push(this.selected_vendors);
      // console.log("DDDDDDDDDaaaaaaaaaaaaaaaaaaDDDDDDDDDDDD",assign_vendors);
      // assign_brand.push(this.brand_id);
      // if(this.user_type=='Quality_Controller'){
      //   assign_brand.push(this.brand_id);
      //   console.log("QQQQQQQQQQQQQQQQQQQQQQQQQ",assign_brand)
      // }
      let arr = [];
      var assign_cat_id = [];
      // var vendor_arr=[];
      assign_cat_id.push(this.sel_subcat);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      if (chkmobileVal) {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // var usertype='0';
        this.login_user_id = userInfo[0].user_id;
        if (this.customer.usertype) {
          usertype = this.customer.usertype;
        }
        // if(userInfo[0].user_type=='Fit_Technician'){
        //   assign_brand='';
        // }
        if (userInfo[0].user_type == "Admin") {
          this.assign_sub_cat = this.sel_subcat;
        } else {
          this.assign_sub_cat = userInfo[0].subcat_assign;
        }
        if (this.customer.role == 4) {
          assign_brand = [];
          var temp = userInfo[0].brand_assign;
          assign_brand.push(temp);
        }
        if (this.user_type == "Quality_Controller") {
          assign_brand = [];
          var temp = this.brand_id;
          assign_brand.push(temp);
          console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT", assign_brand);
        }
        //   if(this.customer.role==7){
        //   var Obj = {

        //             full_name : this.customer.full_name,
        //             email_id : this.customer.email_id,
        //             contact_no : this.customer.contact_no,
        //             password : 12345,
        //             is_active:1,
        //             user_type : this.customer.role,
        //             brands : assign_brand,
        //             created_by : userInfo[0].user_id,
        //             role: this.user_type,
        //             brand_manager : userInfo[0].user_id,
        //             designation : this.customer.designation,

        //             cat_id: this.selected_cat_id,
        //             sub_catid: this.assign_sub_cat,
        //             selected_vendors: this.selected_vendors,

        //             city: this.city,

        //           }
        // }
        let objectuser = {}
        if (this.user_type == "Quality_Controller") {
          objectuser = {
            full_name: this.customer.full_name,
            email_id: this.customer.email_id,
            contact_no: this.customer.contact_no,
            //password: "Firstcry@123",
            is_active: 1,
            user_type: this.customer.role,
            created_by: userInfo[0].user_id,
            role: this.user_type,
            // QC_Executive: userInfo[0].user_id,
            user_id: userInfo[0].user_id,
            city: this.city,
            brand_manager: userInfo[0].user_id,
            selected_vendors: this.selected_vendors,
          };
        } else if(this.user_type == "Buyer"){
          objectuser = {
            full_name: this.customer.full_name,
            email_id: this.customer.email_id,
            contact_no: this.customer.contact_no,
            //password: "Firstcry@123",
            is_active: 1,
            user_type: this.customer.role,
            created_by: userInfo[0].user_id,
            role: this.user_type,
            // QC_Executive: userInfo[0].user_id,
            user_id: userInfo[0].user_id,
            city: this.city,
            brand_manager: userInfo[0].brand_manager,
            selected_vendors: this.selected_vendors,
          };
        } 
        else {
          objectuser = {
            full_name: this.customer.full_name,
            email_id: this.customer.email_id,
            contact_no: this.customer.contact_no,
            //password: "Firstcry@123",
            is_active: 1,
            city: this.city,
            user_type: this.customer.role,
            created_by: userInfo[0].user_id,
            role: this.user_type,
            brand_manager: userInfo[0].user_id,
            designation: this.customer.designation,
            selected_vendors: this.selected_vendors,
          };
        }
        console.log("7777777777777777777", objectuser);

        axios
          .post(`${CONSTANTS.API_URL}/addusersdetails`, objectuser)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              this.added_user = this.result.returnvalue[0].user_type;
              this.addeduser_list = this.result.returnvalue[0].user_id;
              this.selected_cat_id = [];
              this.customer = {};
              // Utils.notify("Added successfully", "success");
              this.$fire({
                text: "Added Successfully",
                type: "success",
                timer: 30000,
              });

              this.getselecteduserbrand();
              this.$router.push("/usersdetails").catch(() => {});

              // if (this.user_type == Quality_Controller)
              // {
              //   this.$router.push('/usersdetails').catch(()=>{});
              // }
              // else {
              // this.$router.push('/addusersdetails').catch(()=>{});

              // }
            } else {
              (this.added_user = []), (this.selected_cat_id = []);
              this.customer = {};
              // Utils.notify(this.result.returnvalue, "error");
              this.$fire({
                text: this.result.returnvalue,
                type: "error",
                timer: 30000,
              });
              this.$router.push("/usersdetails").catch(() => {});
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else {
        // Utils.notify("Please enter valid mobile number", "error");
        this.$fire({
          text: "Please Enter Valid Mobile Number",
          type: "warning",
          timer: 30000,
        });
      }
    },

    //brandlisting
    brandlisting: function() {
      this.isBusy = true;
      axios
        .post(`${CONSTANTS.API_URL}/brandlistingForUser`, {})
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.brandrecord = this.result.returnvalue;
          } else {
            this.brandrecord = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    // getUserAssignedBrandList
    getUserAssignedBrandList: function() {
      this.isBusy = true;

      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;

        var Obj = {
          user_id: this.user_id,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getUserAssignedBrandList`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              this.brandrecord = this.result.returnvalue;
              for (var j = 0; j <= this.brandrecord.length; j++) {
                this.brand_name_arr.push(this.brandrecord[j].brand_title);
              }
            } else {
              this.brandrecord = [];
              this.totalRows = 0;
              this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },

    editcancel: function() {
      this.assign_category = !this.assign_category;
    },

    validateForm2(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.selected_cat_id == 0) {
            this.$fire({
              text: "Please Select Category Name",
              type: "warning",
              timer: 30000,
            });
          } else if (this.sel_subcat.length == 0) {
            // alert("Please Select Subcategory");
            this.$fire({
              text: "Please Select Subcategory",
              type: "warning",
              timer: 30000,
            });
          } else if (this.brand_id == 0) {
            // alert("Please Select Atleast One Brand");
            this.$fire({
              text: "Please Select Atleast One Brand",
              type: "warning",
              timer: 30000,
            });
          } else if (this.brand_id == 0) {
            // alert("Please Select Atleast One Brand");
            this.$fire({
              text: "Please Select Atleast One Brand",
              type: "warning",
              timer: 30000,
            });
          } else if (this.user_type == "Admin") {
            this.assignCatSubBrd();
          }
        }
      });
    },

    assignCatSubBrd: function() {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;

      if (this.user_type == "Admin") {
        var Obj = {
          brands: this.brand_id,
          sub_catid: this.sel_subcat,
          cat_id: this.selected_cat_id,
          user_id: userInfo[0].user_id,
          brand_manager: userInfo[0].user_id,
          user_type: 1,
          selected_vendors: this.selected_vendors,
          created_by: userInfo[0].user_id,
        };
      } else {
        var Obj = {
          brands: this.brand_id,
          sub_catid: this.sel_subcat,
          cat_id: this.selected_cat_id,
          user_id: this.addeduser_list,
          brand_manager: userInfo[0].user_id,
          selected_vendors: this.selected_vendors,
          created_by: userInfo[0].user_id,
        };
      }

      axios
        .post(`${CONSTANTS.API_URL}/assigncatsubctid`, Obj)
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.assigned_data = this.result.returnvalue;
            this.$fire({
              text: "Data added successfully",
              type: "success",
              timer: 30000,
            });
            this.assign_category = !this.assign_category;
            this.getassigncatsubctidlist();
          } else {
            this.$fire({
              text: "Something is wrong, Please try again",
              type: "error",
              timer: 30000,
            });

            (this.assigned_data = []),
              (this.assign_category = !this.assign_category);
            this.getassigncatsubctidlist();
          }
        });
    },

    validateForm3(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.sel_subcat.length == 0) {
            // alert("Please Select Subcategory");
            this.$fire({
              text: "Please Select Subcategory",
              type: "warning",
              timer: 30000,
            });
          }

          //   else
          else if (this.user_type == "Admin") {
            const Obj = {
              id: this.editId,
              brands: this.selected_brandID,
              sub_catid: this.sel_subcat,
              cat_id: this.selected_catID,
              user_id: this.user_id,
              userid: this.$route.params.id,
              brand_manager: userInfo[0].user_id,
            };

            axios
              .post(`${CONSTANTS.API_URL}/updateassigncatsubcatid`, Obj)
              .then((response) => {
                this.result = response.data;
                if (this.result.returnmsg === "Successful") {
                  this.$fire({
                    text: "Data Updated Successfully",
                    type: "success",
                    timer: 30000,
                  });

                  this.isEditModelVisible = !this.isEditModelVisible;
                  this.getassigncatsubctidlist();
                } else {
                  this.$fire({
                    text: "Something is wrong, Please try again",
                    type: "error",
                    timer: 30000,
                  });
                  this.isEditModelVisible = !this.isEditModelVisible;
                }
              });
          }
        }
      });
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const Obj = {
            id: this.deleteId,
          };

          axios
            .post(`${CONSTANTS.API_URL}/deletecatsubcatid`, Obj)
            .then((response) => {
              this.result = response.data;
              if (this.result.returnmsg === "Successful") {
                this.$fire({
                  text: "Data Deleted Successfully",
                  type: "success",
                  timer: 30000,
                });

                this.isDeleteModelVisible = !this.isDeleteModelVisible;
                this.getassigncatsubctidlist();
              } else {
                this.$fire({
                  text: "Something is wrong, Please try again",
                  type: "error",
                  timer: 30000,
                });
                this.isDeleteModelVisible = !this.isDeleteModelVisible;
                this.getassigncatsubctidlist();
              }
            });
        }
      });
    },

    showEditModal(id, cat, brand, bid, cid) {
      this.editId = id;
      this.selected_brandID = bid;
      this.selected_catID = cid.split(" ");
      this.selected_catname = cat;
      this.selected_brandname = brand;
      this.getSubCategoryList(cid.split(" "));
      this.isEditModelVisible = true;
    },

    showDeleteModal(id) {
      this.deleteId = id;
      this.isDeleteModelVisible = true;
    },

    cancelassignmodal: function() {
      this.isEditModelVisible = !this.isEditModelVisible;
    },

    cancelassignmodalD: function() {
      this.isDeleteModelVisible = !this.isDeleteModelVisible;
    },

    cancel: function() {},
  },
};
</script>
<style>
@media (max-width: 1040px) {
  .adduserside {
    display: none;
  }
}
@media (min-width: 1040px) {
  .addusersidebar {
    display: none;
  }
}
/*@media  (max-width: 1024px)
{
 .adduserwidth{
  width: 153%;
 }
}
 @media  (min-width: 768px) 
{
 .adduserwidth{
  width: 153%;
 }
}*/
</style>
